export const itIT = {
    price: 'Prezzo',
    apply: 'Applica',
    filterFor: 'Filtri',
    default: 'Predefinito',
    alphabetic: 'Alfabetico',
    newest: 'Ultimi arrivi',
    popularity: 'Popolarità',
    priceHighToLow: 'Prezzo in ordine decrescente',
    priceLowToHigh: 'Prezzo in ordine crescente',
    showMore: 'Mostra altri risultati',
    showPrev: 'Mostra risultati precedenti',
    noProductsFound: 'Nessun prodotto trovato',
    from: 'da',
    outOfStock: 'Non disponibile',
    addToCart: 'Aggiungi al carrello',
    addProductToCart: 'Aggiungi {0} al carrello',
    showProduct: 'Scopri di più',
    applyFilters: 'Applica filtri',
    orderBy: 'Ordina per:',
    results: 'risultati'
};
export default itIT;
